import { create } from 'zustand';

interface InviteUserModalStore {
  open?: boolean;
  openModal: (params: {
    open?: boolean;
    onClose?: (params: { emails?: string[] }) => void;
  }) => void;
  close: (params: { emails?: string[] }) => void;
  onCloseCallback?: (params: { emails?: string[] }) => void;
}

const useInviteUserModalStore = create<InviteUserModalStore>((set, get) => ({
  open: false,
  onCloseCallback: undefined,

  openModal: ({ open = true, onClose }) => {
    set({ open, onCloseCallback: onClose });
  },

  close: ({ emails }) => {
    const { onCloseCallback } = get();
    set({ open: false, onCloseCallback: undefined });

    // Call onClose callback if defined
    onCloseCallback?.({ emails });
  },
}));

export default useInviteUserModalStore;
